import {
  GET_SATISFACTION,
  GET_SATISFACTION_ERROR,
  SATISFACTION_LOADING,
} from "../actions/types";

const initialState = {
  printers: [],
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SATISFACTION:
      return {
        ...state,
        loading: false,
        printers: payload,
      };
    case GET_SATISFACTION_ERROR:
      return {
        ...state,
        loading: false,
      };
    case SATISFACTION_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
